import { hvoFirestore, vceFirestore } from "../../configs/FirebaseConfig";

/**
 * The Firestore of the shop an order or product belongs to. Shared warehouse data (pick route,
 * product links, pick days, waves) always lives in VCE; this is only for per-shop documents.
 */
export const resolveFirestore = (shopSource) => (shopSource === "HVO" ? hvoFirestore : vceFirestore);

/** Firestore refuses a batch over 500 writes; stay well under it. */
export const BATCH_LIMIT = 450;

/** Commit `(batch) => void` operations on one Firestore in chunks. Stops at the first failure. */
export const commitInChunks = async (firestore, operations) => {
  for (let start = 0; start < operations.length; start += BATCH_LIMIT) {
    const batch = firestore.batch();
    operations.slice(start, start + BATCH_LIMIT).forEach((apply) => apply(batch));
    await batch.commit();
  }
};
